// @ts-nocheck

import { GRNotificationTypes, type GRNotificationType } from '../types/notification';

type MilliSecond = number;

export const DeltaTransitionsDurations: {
  [key: GRNotificationType]: MilliSecond;
} = Object.freeze({
  [GRNotificationTypes.BETSLIP_UPDATE]: 2000,
  [GRNotificationTypes.ROUND_COMPLETE]: 1500,
  [GRNotificationTypes.ROUND_FAILED]: 1500,
});

export const GR_LIST_SCROLL_DURATION: MilliSecond = 750;
